import CloseLargeIcon from '@8x8/oxygen-icon/icons/CloseLargeIcon'
import Button from '@8x8/oxygen-button'
import Checkbox from '@8x8/oxygen-checkbox'
import styled from 'styled-components'

import { Flex } from '~/components/common/containers'

export const StyledCloseLargeIcon = styled(CloseLargeIcon).attrs({
  color: '#5E6D7A'
})`

  cursor: pointer;
`

export const Container = styled.div`
  box-sizing: border-box;
  padding: 16px;
`

export const TitleContainer = styled(Flex)`
  justify-content: space-between;
  line-height: 32px;
  margin-bottom: 16px;
`

export const Title = styled.h1`
  max-width: 303px;
  color: #1c2025;
  font-size: 24px;
  line-height: 32px;
  font-weight: 600;
  margin: 0;
  padding: 0;
`

export const DescriptionContainer = styled.div`
  padding: 16px;
  background: #F8CC7E;
  border-radius: 3px;
  margin-bottom: 22px;
  line-height: 24px;
  font-weight: 600;
  > p:first-child {
    margin-block-start: 0;
  }
  > p:last-child {
    margin-block-end: 0;
  }
`

export const CheckboxContainer = styled(Flex)`
  margin-bottom: 26px;
  color: #1C2025;
`

export const StyledCheckbox = styled(Checkbox)`
  display: flex;
  align-self: flex-start;
`

export const ConfirmedLabel = styled.div`
  margin-left: 8px;
`

export const ButtonsContainer = styled(Flex)`
  justify-content: flex-end;
`

export const StyledConfirmButton = styled(Button).attrs(() => ({
  secondary: true
}))`
  color: #E12D2D;
`

export const StyledGoBackButton = styled(Button)`
  margin-left: 16px;
`
